import { I18n } from '@calendly/i18n'
import { Loader } from '@calendly/ui/components/loader'
import { MinimalButton } from '@calendly/ui/components/minimal-button'
import { isEmpty } from 'lodash-es'
import { Fragment } from 'react'

import { Layout } from 'components/layout'

import { CopyFromOption, CopyToOption, EmptyMessage, NameDivider } from './styles'

const LoaderContent = () => <Layout grow justify="center" align="center"><Loader /></Layout>
const EventTypesContainer = (props) => (
  <Layout direction="column" role="listbox" aria-label={I18n.t('publisher.action.options')} {...props} />
)

export const SearchResults = ({ isLoading, query, results, handleSelection, selectedETs, itemType, fetchMore, isLoadingMore }) => {
  if (isLoading) { return <LoaderContent /> }

  if (isEmpty(results)) {
    let emptyMessage
    if (query === '') {
      emptyMessage = I18n.t('publisher.event_type_editor.sections.available_hours.no_valid_events')
    }

    if (query !== '') {
      emptyMessage = I18n.t('publisher.event_type_editor.sections.available_hours.no_valid_named')
    }
    return <EmptyMessage>{emptyMessage}</EmptyMessage>
  }

  return results?.map(({ id: profileId, type: profileType, name, eventTypes, nextPage }) => (
    <Fragment key={`${profileType}-${profileId}`}>
      <NameDivider>{name}</NameDivider>
      <EventTypesContainer>
        {itemType === 'copy-from' && (
          eventTypes.map((eventType) => (
            <CopyFromOption
              key={eventType.id}
              color={eventType.color}
              name={eventType.name}
              onClick={() => handleSelection(eventType)}
              duration={eventType.duration}
              locationConfigurations={eventType.locationConfigurations}
              parentId={eventType.parentId}
              groupManaged={eventType.isUserGroupManaged}
              selected={String(selectedETs[0]?.id) === String(eventType.id)}
            />
          ))
        )}
        {itemType === 'copy-to' && (
          eventTypes.map((eventType) => (
            <CopyToOption
              key={eventType.id}
              color={eventType.color}
              name={eventType.name}
              onClick={() => handleSelection(eventType)}
              duration={eventType.duration}
              locationConfigurations={eventType.locationConfigurations}
              parentId={eventType.parentId}
              groupManaged={eventType.isUserGroupManaged}
              selected={Boolean(selectedETs.find(({ id: sid }) => String(eventType.id) === String(sid)))}
              disabled={!eventType.canEdit}
              disabledHint={eventType.editLockedHint}
            />
          ))
        )}
      </EventTypesContainer>
      {nextPage && (
        <Layout paddingY="4" justify="center">
          <MinimalButton
            onClick={() => fetchMore({ profileType, profileId, page: nextPage })}
            loading={isLoadingMore}
            fontSize="small"
          >
            {I18n.t('publisher.title.show_more')}
          </MinimalButton>
        </Layout>
      )}
    </Fragment>
  ))
}
